(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('size-guide-page[data-size-guide-root]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var defaultUnit = (root.getAttribute('data-unit') || 'in').toLowerCase();
    var buttons = root.querySelectorAll('.size-guide-unit__btn');
    var unitLabels = root.querySelectorAll('.js-size-guide-unit-label');
    var cells = root.querySelectorAll('td[data-measurement]');
    var factor = 2.54;

    function setUnit(unit) {
      var isCm = unit === 'cm';
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-unit') === unit;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      unitLabels.forEach(function (label) {
        label.textContent = unit.toUpperCase();
      });
      cells.forEach(function (cell) {
        var raw = parseFloat(cell.getAttribute('data-in'));
        if (Number.isNaN(raw)) return;
        var value = isCm ? raw * factor : raw;
        cell.innerHTML = value.toFixed(1) + ' <span class="js-size-guide-unit-label">' + unit + '</span>';
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setUnit(btn.getAttribute('data-unit'));
      });
    });

    setUnit(defaultUnit);

    var tableWraps = root.querySelectorAll('.size-guide-table__wrap');
    function updateTableScrollability() {
      tableWraps.forEach(function (wrap) {
        if (wrap.scrollWidth > wrap.clientWidth) {
          wrap.setAttribute('tabindex', '0');
        } else {
          wrap.removeAttribute('tabindex');
        }
      });
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        updateTableScrollability();
      });
      tableWraps.forEach(function (wrap) {
        ro.observe(wrap);
      });
    } else {
      window.addEventListener('resize', updateTableScrollability);
    }
    updateTableScrollability();
  })();

  } catch(e) { console.error(e); }
})();
})();
